const getProbabilityColor = (proba) => {
  const value = Math.min(1, Math.max(0, proba || 0))
  const hue = value * 120
  const confidence = Math.abs(value - 0.5) * 2
  const lightness = 70 - confidence * 18
  return `hsl(${hue} 85% ${lightness}%)`
}

const getClassForBooleanText = (value) => {
  if (value === 'Yes') return 'text-success'
  if (value === 'No') return 'text-warning'
  return ''
}

const getColorStyle = (value) => {
  if (!Number.isFinite(value) || value < 0 || value > 1) return null

  return {
    backgroundColor: getProbabilityColor(value),
    borderRadius: '0.25rem',
    color: '#111',
    display: 'inline-block',
    minWidth: '4.5rem',
    padding: '0.125rem 0.375rem',
  }
}

export { getProbabilityColor, getColorStyle, getClassForBooleanText }
